import { render, staticRenderFns } from "./OrderDialog.vue?vue&type=template&id=99f0bb58&scoped=true"
import script from "./OrderDialog.vue?vue&type=script&lang=js"
export * from "./OrderDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDialog.vue?vue&type=style&index=0&id=99f0bb58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f0bb58",
  null
  
)

export default component.exports